import React, { useState, useEffect } from "react";
import ProfileBar from "./components/ProfileBar";
import PageTitle from "./components/PageTitle";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Icon from "@mui/material/Icon";
import FormControl from "@mui/material/FormControl";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Select from "@mui/material/Select";
import TableHead from "@mui/material/TableHead";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import { useForm } from "react-hook-form";
import { fetchData, getProfileByToken } from "./js/main";
import { conf } from "./const";
import { useNavigate, useParams } from "react-router-dom";

export default function CreateBill(props) {
  const params = useParams();
  const [bill, setBill] = useState();
  useEffect(() => {
    (async () => {
      if (params && params.bill_no) {
        const Bill = await fetchData("get", "/v3/bill/" + params.bill_no);
        if (
          Bill.canceled &&
          Bill.canceled.status === true &&
          !Bill.canceled.new_bill
        )
          setBill(Bill);
        else alert("Can not replace bill " + Bill.bill_id);
      } else setBill({ invoice_id: {} });
    })();
  }, [params]);

  return (
    <div className="content">
      <ProfileBar profile={props.profile} />
      <PageTitle page={props.page} />
      {bill && bill.invoice_id && <BillForm bill={bill} />}
    </div>
  );
}

function BillForm({ bill }) {
  const [loading, setLoading] = useState(false);
  const { register, getValues, setValue } = useForm();
  const [invoiceDetails, setInvoiceDetails] = useState([]);
  const navitage = useNavigate();
  useEffect(() => {
    if (bill._id) {
      const invoice = bill.invoice_id;
      setValue("debtor_name", invoice.debtor_name);
      setValue("debtor_address", invoice.debtor_address);
      setValue("debtor_email", invoice.debtor_email);
      setValue("debtor_idx", invoice.debtor_idx);
      setValue("remark", invoice.remark);
      setInvoiceDetails(invoice.details);
    } else if (conf.onDev === true) {
      setValue("debtor_name", "นายปราชญ์ สงวนศักดิ์");
      setValue("debtor_address", "สำนักหอสมุด มหาวิทยาลัยเชียงใหม่");
      // setValue("debtor_email", "pratchaya.s@cmu.ac.th");
      setValue("debtor_idx", "3120100603762");
      setValue("remark", "ทดสอบ ON DEV");
    }
  }, [setValue, bill]);

  async function onSubmit(payType) {
    setLoading(true);
    let form = getValues();
    form.details = invoiceDetails;
    let chk = await checkBeforeCreateInvoice(form);
    if (chk === true) {
      let profile = await getProfileByToken();
      form.operator = {
        name: profile.fullname,
        usn: profile.usn,
      };
      form.app_id = "10";
      form.amount = 0;
      for (let item of invoiceDetails) {
        form.amount += parseFloat(item.amount);
      }
      form.pay_type = payType;
      if (bill.invoice_id) {
        form.old_bill = bill._id;
      }
      const result = await fetchData("put", "/v3/invoice", form);
      if (result) {
        navitage(process.env.PUBLIC_URL + "/confirm/" + result.invoice_id);
      }
    }
    setLoading(false);
  }
  function checkBeforeCreateInvoice(send) {
    return new Promise((resolve) => {
      if (send.debtor_name === "" || send.details.length < 1) {
        alert("Please fill completed information");
        resolve(false);
      } else resolve(true);
    });
  }
  function addItem(item, callback) {
    let Items = JSON.parse(JSON.stringify(invoiceDetails));
    Items.push(item);
    setInvoiceDetails(Items);
    if (callback) callback();
  }
  function removeItem(key) {
    let Items = JSON.parse(JSON.stringify(invoiceDetails));
    Items.splice(key, 1);
    setInvoiceDetails(Items);
  }
  return (
    <Grid container spacing={2} sx={{ marginTop: "10px" }}>
      <>
        <Grid item xs={6} md={3} lg={3}>
          <TextField
            label="Payer Name"
            fullWidth
            {...register("debtor_name")}
            id="debtor_name"
            placeholder="ชื่อผู้ชำระเงิน"
            variant="outlined"
            size="small"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid item xs={6} md={3} lg={3}>
          <TextField
            label="Patron Barcode"
            fullWidth
            {...register("patron_code")}
            id="patron_code"
            placeholder="หมายเลขสมาชิกห้องสมุด"
            variant="outlined"
            size="small"
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={6} md={3} lg={3}>
          <TextField
            label="Tax ID / ID Card Number"
            fullWidth
            {...register("debtor_idx")}
            id="debtor_idx"
            placeholder="เลขประจำตัวผู้เสียภาษี/หมายเลขบัตรประชาชน"
            variant="outlined"
            size="small"
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={6} md={3} lg={3}>
          <TextField
            label="e-Mail"
            fullWidth
            {...register("debtor_email")}
            id="debtor_email"
            placeholder="อีเมลสำหรับจัดส่งใบเสร็จ"
            variant="outlined"
            size="small"
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Address"
            fullWidth
            {...register("debtor_address")}
            id="debtor_address"
            placeholder="ที่อยู่"
            variant="outlined"
            size="small"
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Remark"
            fullWidth
            {...register("remark")}
            id="remark"
            placeholder="หมายเหตุ"
            variant="outlined"
            size="small"
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
      </>
      <Grid item xs={12}>
        <BillTable
          items={invoiceDetails}
          onAddItem={addItem}
          onRemoveItem={removeItem}
        />
      </Grid>
      <Grid item xs={4}>
        <Button
          variant="contained"
          fullWidth
          sx={{ maxWidth: "150px" }}
          startIcon={<Icon>qr_code</Icon>}
          onClick={() => onSubmit("qrcode")}
          disabled={loading}
        >
          QR Code
        </Button>
      </Grid>
      <Grid item xs={8} align="right">
        <Button
          variant="contained"
          fullWidth
          sx={{ maxWidth: "150px", marginRight: "5px" }}
          startIcon={<Icon>currency_exchange</Icon>}
          onClick={() => onSubmit("transfer")}
          disabled={loading}
        >
          Transfer
        </Button>
        <Button
          variant="contained"
          fullWidth
          sx={{ maxWidth: "150px" }}
          startIcon={<Icon>attach_money</Icon>}
          onClick={() => onSubmit("cash")}
          disabled={loading}
        >
          Cash
        </Button>
      </Grid>
    </Grid>
  );
}

function BillTable({ items, onAddItem, onRemoveItem }) {
  const { register, getValues, setValue } = useForm();
  const [accounts, setAccounts] = useState();
  useEffect(() => {
    (async () => {
      let accounts = await fetchData("get", "/v3/account/user");
      setAccounts(accounts);
    })();
  }, []);

  useEffect(() => {
    if (accounts) {
      if (conf.onDev === true) {
        let acc = accounts[0];
        if (acc && acc.account_code && acc.chart_code)
          setValue("account", `${acc.account_code}-${acc.chart_code}`);
        setValue("description", "ทดสอบ");
        setValue("amount", "1");
      }
    }
  }, [accounts, setValue]);

  function addItem() {
    let form = getValues();
    let account = form.account.split("-");
    let i = accounts.findIndex(
      (j) => j.account_code === account[0] && j.chart_code === account[1]
    );
    if (i > -1) {
      form = { ...form, ...accounts[i] };
    }
    if (form.description.trim() === "") delete form.description;
    if (form.account && form.account.trim() !== "") {
      onAddItem(form, addCallback());
    }
  }
  function addCallback() {
    setValue("description", "");
    setValue("amount", "0");
  }
  return (
    <div>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell style={{ width: "80px" }}>No.</TableCell>
              <TableCell colSpan="2">Descriptions</TableCell>
              <TableCell style={{ width: "200px" }}>Amount</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell align="center">
                <Icon>add</Icon>
              </TableCell>
              <TableCell align="center" className="inputPadding" colSpan="2">
                <div>
                  <FormControl variant="outlined" size="small" fullWidth>
                    <Select native {...register("account")} fullWidth>
                      <option value=""></option>
                      {accounts &&
                        accounts.map((acc) => (
                          <option
                            key={acc._id}
                            value={`${acc.account_code}-${acc.chart_code}`}
                          >
                            {acc.biller_name}
                          </option>
                        ))}
                    </Select>
                  </FormControl>
                </div>
                <div style={{ marginTop: "3px" }}>
                  <TextField
                    fullWidth
                    {...register("description")}
                    id="description"
                    placeholder="Detail"
                    variant="outlined"
                    size="small"
                  />
                </div>
              </TableCell>
              <TableCell align="center" className="inputPadding">
                <div style={{ paddingBottom: "3px" }}>
                  <TextField
                    fullWidth
                    {...register("amount")}
                    id="amount"
                    placeholder="Amount"
                    variant="outlined"
                    size="small"
                    inputProps={{
                      style: { textAlign: "center" },
                      type: "number",
                    }}
                  />
                </div>
                <div>
                  <Button
                    variant="contained"
                    fullWidth
                    color="success"
                    startIcon={<Icon>add</Icon>}
                    onClick={addItem}
                  >
                    Add Item
                  </Button>
                </div>
              </TableCell>
            </TableRow>
            {items.map((item, key) => (
              <TableRow key={key}>
                <TableCell align="center">{key + 1}</TableCell>
                <TableCell align="center" sx={{ width: "150px" }}>
                  {item.account_code}
                </TableCell>
                <TableCell>
                  <Stack direction="row" spacing={2}>
                    <IconButton
                      sx={{ padding: "0px 0px" }}
                      color="error"
                      onClick={() => onRemoveItem(key)}
                    >
                      <Icon>clear</Icon>
                    </IconButton>
                    <div>
                      <div>{item.biller_name}</div>
                      <div>{item.description && `(${item.description})`}</div>
                    </div>
                  </Stack>
                </TableCell>
                <TableCell align="center">
                  {parseFloat(item.amount).toLocaleString()}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
